function bmFireJelly ( eventName, props, origin ) {
	if (typeof jelly == 'undefined') return;

	eventName = eventName.replace(/ /g, "_" );
	var results = origin == 'jellyFormat' ? props : {};
	var customer = wdgGetSavedCustomer();
	results.SourceInfo = { name: "site" };
	
	customer = (!customer && props.hasOwnProperty('Customer')) ? props.Customer : {};
	customer = customer || {};
	if (!customer.DisplayId) {
		customer.DisplayId = 0;
	}
	if (!customer.Language) {
		var language_code = icl_vars ? icl_vars.current_language : 'en';
		customer.Language = languageCodeToFullLanguage(language_code);
	}
	if (!customer.Regulation) {
		customer.Regulation =  bm_callbacks_get_regulation();
	}
	if (eventName == "login_failure") {
		customer.UserName = $( "#Username" ).val();
	} else if (eventName == "fr_failure") {
		customer.UserName = $( "#Email" ).val();
	}
	results.Customer = customer;
	
	if (origin == "wizard-view" || origin == "popup-close") {
		results.Slide = copyProperties(props, ['slideName', 'slideType', 'popupName']);
	} else if (origin == "widget-costumerAnswer") {
		results.Questionnaire = copyProperties(props, ['answer', 'questionName']);
	} else if (origin == "widget-failure") {
		results.Error = props || [];
	}

	jelly.fireEvent(eventName, results);
	
	function copyProperties(object, properties) {
		var i = 0,
			length = properties.length,
			result = {};
	
		for (i = 0; i < length; i++) {
			var property_name = properties[i];
			if (object.hasOwnProperty(property_name)) {
				result[property_name] = object[property_name];
			}
		}
	
		return result;
	}
	
	function languageCodeToFullLanguage(code){
		var fullLanguage = code ;
		switch (code) {
			case 'en' : fullLanguage = 'English' ; break ;
			case 'ru' : fullLanguage = 'Russian' ; break ;
			case 'ar' : fullLanguage = 'Arabic' ; break ;
			case 'de' : fullLanguage = 'German' ; break ;
			case 'es' : fullLanguage = 'Spanish' ; break ;
			case 'it' : fullLanguage = 'Italian' ; break ;
			case 'nl' : fullLanguage = 'Dutch' ; break ;
			case 'pt-br' : fullLanguage = 'Portuguese' ; break ;
			case 'pl' : fullLanguage = 'Polish' ; break ;
			case 'sv' : fullLanguage = 'Swedish' ; break ;
			case 'nb' : fullLanguage = 'Norwegian' ; break ;
			case 'th' : fullLanguage = 'Thai' ; break ;
			case 'fr' : fullLanguage = 'French' ; break ;
		}
		return fullLanguage ;
	}
}